import AccessTimeIcon from "@mui/icons-material/AccessTime";
import InfoOutlineIcon from "@mui/icons-material/InfoOutlined";
import { Stack, Typography } from "@mui/material";
import { type FC } from "react";

import { RichTooltip } from "~/components/UI/RichTooltip";
import { useEventDateRange } from "~/feature/event/components/EventDateRange/useEventDateRange";
import { useGroupedEventCountDown } from "~/hooks/useGroupedEventCountdown";
import type { IAggregatedEvent } from "~/types/event";

const TOOLTIP_TEXT =
  "This is an estimated end date. See the rules below for the exact resolution criteria.";

interface IEventDateRangeProps {
  event: IAggregatedEvent;
}

export const EventDateRange: FC<IEventDateRangeProps> = ({ event }) => {
  const { hideCountdown } = useGroupedEventCountDown(event);
  const dateRange = useEventDateRange(event);

  if (!dateRange || hideCountdown || event.resolved) return;

  return (
    <Stack direction="row" spacing={0.5} sx={{
      alignItems: "center"
    }}>
      <AccessTimeIcon fontSize="small" />
      <Typography variant="caption" color="gray" sx={{
        fontWeight: "500"
      }}>
        {dateRange}
      </Typography>
      <RichTooltip title={TOOLTIP_TEXT}>
        <InfoOutlineIcon
          color="disabled"
          sx={{ fontSize: "14px", marginLeft: "4px" }}
        />
      </RichTooltip>
    </Stack>
  );
};
